/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import I18N from '@leverege/i18n';
import { Pane } from '@leverege/ui-elements';
import GridView from "./GridView.js";
import DashboardContext from "../shared/DashboardContext.js";
const {
  t
} = I18N.ns('uiDashboard.view.DashboardView');
export default function Dashboard(props) {
  const {
    models,
    value,
    sharedProps,
    editors,
    optionEditors,
    viewers,
    options,
    style,
    className,
    onChange,
    eventData,
    variant = 'dashboard',
    getModelCreators,
    noDataView: NoDataView = DefaultNoDataView,
    noDataText = t('noDataText')
  } = props;
  let content = /*#__PURE__*/React.createElement(GridView, {
    onChange: onChange,
    eventData: eventData,
    value: value
  });
  if (value.cards.length === 0) {
    content = /*#__PURE__*/React.createElement(NoDataView, {
      noDataText: noDataText
    });
  }
  return /*#__PURE__*/React.createElement(DashboardContext, {
    models: models,
    editors: editors,
    viewers: viewers,
    optionEditors: optionEditors,
    sharedProps: sharedProps,
    getModelCreators: getModelCreators,
    options: options
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: variant,
    style: style,
    className: className
  }, content));
}
function DefaultNoDataView(props) {
  const {
    noDataText
  } = props;
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "dashboardNoData",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", null, noDataText));
}